import { Injectable } from '@angular/core';

export type CategoryType =
  | 'DEFAULT:CONDITIONAL'
  | 'DEFAULT:VARIABLE'
  | 'DEFAULT:CALCULATED'
  | 'DEFAULT:SIGNATURE'
  | 'CUSTOM';

export interface CategoryPayload {
  name: string;
  description?: string;
  type: CategoryType;
  owner: string;
  form: string;
}

@Injectable({
  providedIn: 'root',
})
export class CategoryHelper {
  /**
   * Payload structure required by the backend to create a category
   */

  buildPayload(
    name: string,
    owner: string,
    form: string,
    description = '',
    type: CategoryType = 'CUSTOM'
  ): CategoryPayload {
    return {
      name,
      description,
      type,
      owner,
      form,
    };
  }
}
